import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input, NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ServiceMessageComponent } from '@core/components/service-message/service-message.component';
import { DEFAULT_DIALOG_CONFIG, SereviceMessageType } from '@core/constants/serviceMessage.const';
import { IApp } from '@core/models/app.interfaces';
import IDocument = IApp.IDocument;
import { environment } from '@env/environment';
import {
  CreditAdjustmentReportViewAddressComponent
} from '@module/credit-adjustment-report/components/credit-adjustment-report-view-address/credit-adjustment-report-view-address.component';
import {
  ICreditCreationReport,
} from '@module/credit-creation-reports/credit-creation-reports.types';
import {
  CreditCreationReportsService,
} from '@module/credit-creation-reports/services/credit-creation-reports.service';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ModalService } from '@shared/services/modal.service';
import { UploadDocumentService } from '@shared/services/upload-document.service';
import { Subject } from 'rxjs';
import { Dialog, DialogModule } from 'primeng/dialog';
import { CARApplyPrefix } from '@module/credit-adjustment-report/const/credit-adjustment-report.const';
import { CreditAdjustmentReportService } from '@module/credit-adjustment-report/credit-adjustment-report.service';
import { WCAGLabelDirective } from '@shared/directives/wcag-label.directive';
import { DisableOnUploadDirective } from '@shared/directives/disable-on-upload.directive';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DocumentsComponent } from '@shared/components/documents/documents.component';
import { NgSelectModule } from '@shared/components/ng-select/ng-select.module';

declare var ResizeObserver;

@Component({
  selector: 'app-add-details-adjustment-form',
  templateUrl: './add-details-adjustment-form.component.html',
  styleUrls: ['./add-details-adjustment-form.component.scss'],
  imports: [TranslateModule, FormlyModule, ReactiveFormsModule, DialogModule,
    WCAGLabelDirective, DisableOnUploadDirective, CommonModule, FontAwesomeModule,
    DocumentsComponent, NgSelectModule, FormsModule ]
})
export class AddDetailsAdjustmentFormComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() form = new FormGroup({});
  @Input() ccrForm = new FormGroup({});
  @Input() masterProject: any;
  @Output() modelIdUpdate = new EventEmitter();

  @ViewChild('leftCol', {static: true}) leftCol: ElementRef;
  @ViewChild('rightCol', {static: true}) rightCol: ElementRef;
  @ViewChild('dialog', { static: false }) dialog: Dialog;
  public report: ICreditCreationReport;

  height;
  observer;
  private initial = true;

  // Adjustment report model
  public model: any = {};
  public fields: FormlyFieldConfig[];

  // Original CCR model
  public ccrModel: any = {};
  public ccrFields: FormlyFieldConfig[];

  public needMoreInfoFields: FormlyFieldConfig[];
  public documents: IDocument[];
  public isDocumentUploadInProgress = false;

  public visible = true;
  private _destroy$ = new Subject<any>();

  public currentStepObj;
  public downloadSelected;
  public taskList = [];
  public documentUploadDisabled = false;
  missingDocsCode: string[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<AddDetailsAdjustmentFormComponent>,
    private service: CreditCreationReportsService,
    private adjustmentReportService: CreditAdjustmentReportService,
    private uploadDocumentService: UploadDocumentService,
    private translateService: TranslateService,
    private modalService: ModalService,
    private zone: NgZone,
  ) { }

  ngOnInit() {
    this.currentStepObj = this.data.currentStepObj;
    this.currentStepObj.onBeforeAddDetails();
    this.data.section && (this.currentStepObj.section = this.data.section);
    this.currentStepObj.dialogRef = this.dialogRef;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.currentStepObj.ccrModel = {...this.currentStepObj.ccrModel}
      this.currentStepObj.model = {...this.currentStepObj.model}

      this.enableFieldsForAddDetails();
      this.currentStepObj.disableExtraSections();
      if(this.currentStepObj.model.initiateAddDetails || this.currentStepObj.model.isCarRow){
        this.currentStepObj.form.get('sameVolumeAsReportedInCCR')?.disable();
      }
    });
    this.initResizeObserver();
  }

  enableFieldsForAddDetails() {
    if (!this.data.enableFacilityFuelFlag) {
      this.currentStepObj.ccrForm.get('facility').get('id').disable();
      this.currentStepObj.ccrForm.get('fuel').get('id').disable();
      this.currentStepObj.ccrForm.get('fuelingStationRegisteredInCats')?.disable();
      this.currentStepObj.ccrForm.get('fuelingStation')?.get('civicAddress')?.disable();
      this.currentStepObj.ccrForm.get('fuelingStation')?.get('postalAddress')?.disable();
      this.currentStepObj.ccrForm.get('fuelingStation')?.get('accountName')?.disable();
      this.currentStepObj.ccrForm.get('fuelingStation')?.get('name')?.disable();
      this.currentStepObj.ccrForm.get('searchedStationId')?.disable();
      this.currentStepObj.ccrForm.get('searchedOrganizationId')?.disable();

    }
    
  }

  scrollToTop(): void {
    setTimeout(() => {
      this.dialog.el.nativeElement.querySelector('.p-dialog-content').scrollTo(0, 0);
    }, 500);
  }

  public save() {
    if (!this.requiredNestedFields) {
      return;
    }
    if (this.currentStepObj.detailSectionDocumentUploadConfig &&
        !this.uploadDocumentService.checkMandatoryDocuments(
          this.missingDocsCode,
          this.currentStepObj.detailSectionDocumentUploadConfig,
          this.currentStepObj.optionalDocsWithPlaceholderCodes
        )) {
        return;
    }
    this.currentStepObj.save(this.dialogRef);
  }

  public close(): void {
    if (this.currentStepObj.form.touched && this.currentStepObj.form.dirty && !this.adjustmentReportService.disabled ) {
      const sub$ = this.service.openConfirmationModal('confirmOnClose').subscribe(result => {
        sub$.unsubscribe();
        if (result) {
          this.dialogRef.close(false);
        }
      });
    } else {
      this.dialogRef.close(false);
    }
  }

  documentUploadHandler(documentResult: IApp.IEmmitedDocs): void {
    this.documents = documentResult.docs;
    this.missingDocsCode = documentResult.missingDocsCode;
    this.isDocumentUploadInProgress = documentResult.docs
      .filter(document => document._uploadStatus)
      .some(document => document._uploadStatus !== 'CLEAN');
  }

  public downloadTemplate(ev) {
    let uri = '/account-service/document/downloadTemplate/';
    const temlateMap = {
      DOCUMENT_REQUIRED_FOR_INFROMATION_ON_PUBLIC_CHARGING_STATIONS: {
        en: 'PublicChargingStation.xlsx',
        fr: 'BorneDeRechargePublique.xlsx'
      },
      DOCUMENT_REQUIRED_FOR_INFROMATION_ON_PRIVATE_CHARGING_STATIONS: {
        en: 'PrivateChargingStation.xlsx',
        fr: 'BorneDeRechargePrivee.xlsx'
      }
    }

    if (ev.id) {
      uri += temlateMap[ev.id][this.translateService.currentLang];
      this.uploadDocumentService.downloadDocument(`${ environment.apiUrl }${uri}`);
      setTimeout(() => {
        this.downloadSelected = null;
        (document.activeElement as HTMLElement).blur();
        }, 0,
      );
    }
  }

  private get requiredNestedFields(): boolean {
    const missingNestedFields = this.currentStepObj.validateRequiredNestedFields;
    if (Object.keys(missingNestedFields).length) {
      this.nestedFieldsRequired(missingNestedFields);
      return false;
    } else {
      return true;
    }
  }

  private nestedFieldsRequired(missingFields) {
    let msg = '';
    Object.keys(missingFields).forEach(key => msg += `<li>${ this.translateService.instant(missingFields[key]) }</li>`);
    const metaData = [`<ol type="a">${ msg }</ol>`];
    this.modalService.open(
      ServiceMessageComponent,
      {
        messages: [
          {
            message: 'mandatoryNestedFieldsRequired',
            metaData,
          },
        ],
        type: SereviceMessageType.ERROR,
      },
      true,
      DEFAULT_DIALOG_CONFIG,
    );
  }

  private _hasDocumentConfigs() {
    return this.currentStepObj.detailSectionDocumentUploadConfig &&
      this.currentStepObj.detailSectionDocumentUploadConfig.documentUploadConfigs;
  }

  private initResizeObserver() {
    this.observer = new ResizeObserver(entries => {
      this.zone.run(() => this.adjustRowHeight(entries[0].target));
    });
    const rightColRows = Array.from(this.rightCol.nativeElement.querySelector('formly-group').children);
    rightColRows.forEach((row: HTMLElement, idx: number) => {
        row.setAttribute('data-index', String(idx));
        this.observer.observe(row);
      });

    rightColRows.forEach(el => this.adjustRowHeight(el as HTMLElement, true));
  }

  private removeResizeObserver() {
    Array.from(this.rightCol.nativeElement.querySelector('formly-group').children)
      .forEach((row: HTMLElement, idx: number) => {
        row.setAttribute('data-index', String(idx));
        this.observer.observe(row);
      });
  }

  private adjustRowHeight(el: HTMLElement, initial: boolean = false): void {
    const leftColItems = this.leftCol.nativeElement.querySelector('formly-group').children;
    const rowIndex = Number(el.getAttribute('data-index'));
    const rowHeight = el.clientHeight;
    const leftRowHeight = leftColItems[rowIndex].clientHeight;
    if (initial && leftRowHeight >= rowHeight) {
      el.style.minHeight = `${leftRowHeight}px`;
      leftColItems[rowIndex].style.minHeight = `${leftRowHeight}px`;
    } else {
      leftColItems[rowIndex].style.height = `${rowHeight}px`;
    }
  }

  public viewFacilityDetails(event) {
    event && event.preventDefault();
    this.modalService.open(CreditAdjustmentReportViewAddressComponent, {
      facility: this.currentStepObj.ccrModel.facility,
      tooltip: this.getTooltip()
    }, true).afterClosed();
  }

  getTooltip(){
    let stepCode = this.currentStepObj.model.step.code;
    switch (stepCode) {
      case 'STEP-1':
        return CARApplyPrefix('step1_tooltip','.tooltip');
      case 'STEP-2':
        return CARApplyPrefix('step2_tooltip','.tooltip')
      case 'STEP-3':
        return CARApplyPrefix('step3_tooltip','.tooltip')
      case 'STEP-4':
        return CARApplyPrefix('step4_tooltip','.tooltip')
      case 'STEP-5':
        return CARApplyPrefix('step5_tooltip','.tooltip')
      case 'STEP-6':
        return CARApplyPrefix('step6_tooltip','.tooltip')
      case 'STEP-7':
        return CARApplyPrefix('step7_tooltip','.tooltip')
      case 'STEP-8':
        return CARApplyPrefix('step8_tooltip','.tooltip')

    }
  }

  ngOnDestroy() {
    this.initial = true;
    this._destroy$.next(null);
    this._destroy$.complete();
    this.removeResizeObserver();
  }

}
